<!-- Search bar -->
<div class="search-bar">
  <span class="p-input-icon-left search-input-wrap">
    <i class="pi pi-search"></i>
    <input
      type="text"
      pInputText
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearch()"
      placeholder="Search scripts by name or description…"
      class="p-inputtext-sm"
    />
  </span>
</div>

<p-table
  #scriptsTable
  [value]="scripts"
  [lazy]="true"
  (onLazyLoad)="loadScripts($event)"
  dataKey="id"
  [paginator]="true"
  [(first)]="skip"
  [rows]="limit"
  [totalRecords]="totalRecords"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  breakpoint="620px"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>Hooks</th>
      <th class="status-col">Status</th>
      <th class="actions-col"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-script>
    <tr class="selectable-row" (click)="selectScript(script)">

      <!-- Name + description -->
      <td>
        <span class="p-column-title">Name:</span>
        <div class="name-cell">
          <strong>{{ script.name }}</strong>
          <span *ngIf="script.scriptUrl" class="source-badge">
            <i class="pi pi-link"></i> URL
          </span>
          <span *ngIf="!script.scriptUrl && script.code" class="source-badge inline">
            <i class="pi pi-code"></i> Inline
          </span>
        </div>
        <div *ngIf="script.description" class="script-description">{{ script.description }}</div>
      </td>

      <!-- Hooks -->
      <td>
        <span class="p-column-title">Hooks:</span>
        <span class="hook-tags">
          <p-tag
            *ngFor="let hook of (script.hooks | slice:0:4)"
            [value]="hook"
            severity="info"
            styleClass="hook-tag"
          ></p-tag>
          <span *ngIf="script.hooks?.length > 4" class="more-hooks">
            +{{ script.hooks.length - 4 }} more
          </span>
          <span *ngIf="!script.hooks?.length" class="text-secondary">—</span>
        </span>
      </td>

      <!-- Enabled status -->
      <td class="status-col">
        <span class="p-column-title">Status:</span>
        <p-tag
          [value]="script.enabled ? 'Enabled' : 'Disabled'"
          [severity]="script.enabled ? 'success' : 'secondary'"
        ></p-tag>
      </td>

      <!-- Actions (stop propagation so row click doesn't fire) -->
      <td class="actions-col" (click)="$event.stopPropagation()">
        <button
          *ngIf="hasInstallHook(script)"
          type="button"
          pButton
          icon="pi pi-download"
          class="p-button-text p-button-sm p-button-secondary"
          pTooltip="Run install hook (outputs setup instructions to server log)"
          tooltipPosition="left"
          (click)="runInstall(script)"
        ></button>
        <button
          type="button"
          pButton
          icon="pi pi-pencil"
          class="p-button-text p-button-sm"
          pTooltip="Edit script"
          tooltipPosition="left"
          *hasPermission="['scripts.update']"
          (click)="openEdit(script)"
        ></button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4" class="empty-message">
        <i class="pi pi-code"></i>
        <p *ngIf="!searchTerm">No scripts yet. Create one to get started.</p>
        <p *ngIf="searchTerm">No scripts matching "<strong>{{ searchTerm }}</strong>".</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<app-mutate-script #mutate></app-mutate-script>
